import { ChangeEvent, FC, ReactElement } from 'react';
export interface IBucketCheckboxProps {
    title: string;
    checked?: boolean;
    icon?: ReactElement;
    onChange: (event: boolean) => void;
}

export const BucketCheckbox: FC<IBucketCheckboxProps> = ({ title, checked, icon, onChange }) => {
    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement> | boolean) => {
        if (typeof event !== 'boolean') {
            onPropagationEventCancel(event);
            onChange(event.target.checked);
        } else {
            onChange(event);
        }
    };

    const onPropagationEventCancel = (
        event: ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLDivElement, MouseEvent>,
    ) => {
        event.preventDefault();
        event.stopPropagation(); // window click event closes the menu if open so we need to stop that
    };

    return (
        <div
            className="flex items-center gap-2"
            onClick={(event) => {
                onPropagationEventCancel(event);
                handleCheckboxChange(!checked);
            }}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => handleCheckboxChange(e)}
                className="w-4 h-4 text-blue-600 bg-gray-100 border border-gray-300 !rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />
            {icon}
            <label>{title}</label>
        </div>
    );
};
